// pages/admin/PaymentProcessesPage.tsx
import React from 'react';
import PaymentProcessManagement from "@/modules/admin/fsps/components/PaymentProcessManagement";

const PaymentProcessesPage: React.FC = () => {
    return (
        <div className="p-4">
            <PaymentProcessManagement />
        </div>
    );
};

export default PaymentProcessesPage;